import { render } from "./Ave.vue?vue&type=template&id=249b8097&scoped=true"
import script from "./Ave.vue?vue&type=script&lang=js"
export * from "./Ave.vue?vue&type=script&lang=js"

import "./Ave.vue?vue&type=style&index=0&id=249b8097&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-249b8097"

export default script